import { useEffect } from 'react';
import { useKeycloak } from "@react-keycloak/web";
import { Link, useParams, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Row, Table } from 'reactstrap';
import axios from 'axios';
import { setMenuSelected } from '../redux/actions/menuActions';
import { setVybaveni } from '../redux/actions/prvkyActions';
//
import TextOrMdash from '../comp/TextOrMdash';
import DisplayFoto from '../comp/DisplayFoto';
//
import URLEndPointBE from '../comp/URLEndPointBE';
import DeEscapeTxt from '../comp/DeEscapeTxt';

function ViewingVybaveni() {
    const { keycloak, initialized } = useKeycloak();
    const FetchSetVybaveni = async () => {
        const response: any = await axios
            .get(URLEndPointBE+`/listing/vybaveni`)
            .catch((error) => {
                console.log("Err", error)
            });
        //return response.data;    
        dispatch(setVybaveni(response.data))
    }
    let { vybaveniId } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
            //potential succ from insertion/edit redirect
            const {state} = useLocation();
            console.log(state)

    const vybaveni = useSelector((state: any) => state.allPrvky.vybaveni);
    let vybaveni_vybaveniId = vybaveni.find((vyb: any) => (vyb.id===vybaveniId)) 
    
    const viditelnost = useSelector((state: any) => state.miscDicts.viditelnost);
    
    console.log("displaying vybaveni")
    console.log(vybaveni_vybaveniId) 

    const DeleteVybaveni = () => {
        console.log("DeleteVybaveni() " + vybaveniId);
        axios.delete(URLEndPointBE+`/vybaveni/`+vybaveniId, { headers: {"Authorization" : `bearer ${keycloak.token}`, 'Content-Type': 'application/json'}})
        .then((response) => {
            console.log(response);
            //if response.data success - go /listing/vybaveni
            console.log(response.data);
            console.log(response.data.success);
            if(response.data.success==1) {
                console.log("redirecting")
                setTimeout(function() {
                    navigate('/listing/vybaveni', {state: {succ: true, type: 'SMAZANI', item: 'VYBAVENI'}});
                }, 1500);
            }
            else {
                console.log ("err")
            }
        })
        .catch(function(error) {
            console.log(error);
        })
    }
    useEffect(() => {
        dispatch(setMenuSelected("vybaveni"));
        FetchSetVybaveni();

        if (vybaveniId && vybaveniId !== "")
            console.log("vybaveniId && vybaveniId !== \"\"")            
        return () => {
            //why?
        };
    }, [vybaveniId])

    return (
        <Container>
        {/*/@ts-ignore*/}
        {(state?.succ)?<Row className={"succRow"}>
        {/*/@ts-ignore*/}
        <span className={"succTxtInside"}>Úspěch - {state?.type} {state?.item} </span>
        </Row>:<></>}
            <Table hover>
                <thead>
                    <tr>
                        <th className='justWrap'>{DeEscapeTxt(vybaveni_vybaveniId?.kod)}</th>
                        <th><span>{DeEscapeTxt(vybaveni_vybaveniId?.nazev)}</span>
                            <span>&nbsp;
                            {keycloak.authenticated && ( <span>
                            <Link className="navRemoveUnderscoreInLinkA" to={"/vybaveni/edit/"+vybaveni_vybaveniId?.id}>
                                <span className="katBtnStyle printHide" >EDITOVAT</span>
                            </Link> &nbsp;
                            <span className="katBtnStyle ptHover printHide" onClick={() => {DeleteVybaveni()}}>SMAZAT</span>
                            </span>)}
                            </span>
                            <span className="print" onClick={()=>window.print()}>&nbsp;&#9113;&nbsp;</span></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row" className='justWrap'>VZOREK</th>
                        <td align='center'>{(typeof (vybaveni_vybaveniId?.foto) !== 'undefined' && vybaveni_vybaveniId?.foto != null)
                        ? <span style={{display:"inline-block", width:"340px"}}><div>{vybaveni_vybaveniId?.foto.map((foto: any) => <DisplayFoto key={foto.fotoId} foto={foto}/>)}</div></span>
                        : <td>&mdash;</td>}</td>
                    </tr>
                    <tr>
                    <th scope="row" className='justWrap'>RODINA</th>
                        <td><TextOrMdash text={vybaveni_vybaveniId?.vybaveniPouziti[0].rodina_kod}/></td>{/*straight vybaveniPouziti[0]->{"rodina_kod":"MOD"}*/}
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>VIDITELNOST</th>
                        <td>{(typeof (viditelnost) !== 'undefined' && viditelnost != null)
                            ? <TextOrMdash text={viditelnost.find((vid: any) => vid.key===vybaveni_vybaveniId?.viditelnost)?.value} />
                            : <div>&mdash;</div>}</td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>MODIFIKACE</th>
                        <td><TextOrMdash text={DeEscapeTxt(vybaveni_vybaveniId?.modifikace)}/></td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>POPIS</th>
                        <td><TextOrMdash text={DeEscapeTxt(vybaveni_vybaveniId?.popis)}/></td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>DESIGN</th>
                        <td><TextOrMdash text={DeEscapeTxt(vybaveni_vybaveniId?.design)}/></td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>ERGONOMIE</th>
                        <td><TextOrMdash text={DeEscapeTxt(vybaveni_vybaveniId?.ergonomie)}/></td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>MATERIAL</th>
                        <td><TextOrMdash text={DeEscapeTxt(vybaveni_vybaveniId?.material)}/></td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>SERVIS</th>
                        <td><TextOrMdash text={DeEscapeTxt(vybaveni_vybaveniId?.servis)}/></td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>DOSTUPNOST</th>
                        <td><TextOrMdash text={DeEscapeTxt(vybaveni_vybaveniId?.dostupnost)}/></td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>CERTIFIKAT</th>
                        <td><TextOrMdash text={DeEscapeTxt(vybaveni_vybaveniId?.certifikat)}/></td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>CENOVA HLADINA</th>
                        <td><TextOrMdash text={DeEscapeTxt(vybaveni_vybaveniId?.cenovahladina)}/></td>
                    </tr>
                </tbody>
            </Table>
            </Container>
    )
}
export default ViewingVybaveni